import { GsbEntityDef } from "./gsb-entity-def.model";

import { GsbModule } from "./gsb-module.model";

import { GsbUser } from "./gsb-user.model";

export class PropertyMap {
  _entDefName?: string;
  name?: string;
  sourceColumn?: string;
  skipValidation?: boolean;

  constructor(obj?: Partial<PropertyMap>) {
      Object.assign(this, obj);
      this._entDefName = "PropertyMap";
  }
}

export interface ColumnMapping {
  title: string; // CSV column header
  propertyMap: PropertyMap[]; // Path to the property (e.g. ['productVariant', 'product', 'title'])
  isUnique: boolean; // Whether this column contains unique values
  valTitle: string; // Display name for the property path
}

export class GsbImportTemplate {
    _entDefName?: string;
    module_id?: string;
    module?: GsbModule;
    entityDefinition_id?: string;
    lastUpdatedBy?: GsbUser;
    entityDefinition?: GsbEntityDef;
    createdBy?: GsbUser;
    lastUpdateDate?: Date;
    lastUpdatedBy_id?: string;
    id?: string;
    title?: string;
    headers?: string; // JSON string containing array of ColumnMapping objects
    createDate?: Date;
    createdBy_id?: string;
    
    get columnMappings(): PropertyMap[] {
        if (!this.headers) return [];
        try {
            return JSON.parse(this.headers);
        } catch {
            return [];
        }
    }

    constructor(obj?: Partial<GsbImportTemplate>) {
        Object.assign(this, obj);
        this._entDefName = "GsbImportTemplate";
    }
}